import { useRef, useState } from "react";

const PartnerAppSurveyReadOnlyRow = ({ index, t, partnerAppSurveyItem, handleDeleteClick, oddIdx, setError, handleSubmit }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const canReadRef = useRef(null);
    const [isCanRead, setIsCanRead] = useState(partnerAppSurveyItem.canRead);
    const canUpdateSupRef = useRef(null);
    const [isCanUpdateSup, setIsCanUpdateSup] = useState(partnerAppSurveyItem.takeCorrectiveActionOnSupplier);
    const canWriteRef = useRef(null);
    const [isCanWrite, setIsCanWrite] = useState(partnerAppSurveyItem.canWrite);
    const canReviewRef = useRef(null);
    const [isCanReview, setIsCanReview] = useState(partnerAppSurveyItem.canReview);
    const canReadOwnRef = useRef(null);
    const [isCanReadOwn, setIsCanReadOwn] = useState(partnerAppSurveyItem.canReadOwn);

    function submitComplete() {
        setIsSubmit(false);
    }

    function submitDelete(event, partnerAppSurveyItem) {
        setError("");
        setIsSubmit(true);
        handleDeleteClick(event, partnerAppSurveyItem, submitComplete);
    }

    const onResponseChange = (event) => {
        const { name, id } = event.target;
        if (name.startsWith("canRead_")) {
            setIsCanRead(event.target.checked);
        } else if (name.startsWith("canWrite_")) {
            setIsCanWrite(event.target.checked);
        } else if (name.startsWith("canReview_")) {
            setIsCanReview(event.target.checked);
        } else if (name.startsWith("canReadOwn_")) {
            setIsCanReadOwn(event.target.checked);
        } else if (name.startsWith("canUpdateSup_")) {
            setIsCanUpdateSup(event.target.checked);
        }
    }

    function handleEditClick(event) {
        setIsSubmit(false);
        setIsEditMode(true);
    }

    function submitUpdate(event, partnerAppSurveyItem) {
        setError("");
        setIsSubmit(true);
        let updatedValues = {
            partnerKey: partnerAppSurveyItem.partnerKey,
            appSurveyKey: partnerAppSurveyItem.appSurveyKey,
            canRead: canReadRef.current.checked,
            takeCorrectiveActionOnSupplier: canUpdateSupRef.current.checked,
            canWrite: canWriteRef.current.checked,
            canReview: canReviewRef.current.checked,
            canReadOwn: canReadOwnRef.current.checked,
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }
    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }
    function submitCancel(event, partnerAppSurveyItem) {
        setError("");
        setIsCanRead(partnerAppSurveyItem.canRead);
        setIsCanUpdateSup(partnerAppSurveyItem.takeCorrectiveActionOnSupplier);
        setIsCanWrite(partnerAppSurveyItem.canWrite);
        setIsCanReview(partnerAppSurveyItem.canReview);
        setIsCanReadOwn(partnerAppSurveyItem.canReadOwn);
        setIsEditMode(false);
        setIsSubmit(false);
    }
    return (
        <tr key={index}>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerAppSurveyItem.appDisplayName}</td>
            <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerAppSurveyItem.surveyDisplayName}</td>
            {isEditMode ? (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canReadRef}
                            name={"canRead_" + partnerAppSurveyItem.appSurveyKey}
                            id={"canRead_" + partnerAppSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanRead}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canUpdateSupRef}
                            name={"canUpdateSup_" + partnerAppSurveyItem.appSurveyKey}
                            id={"canUpdateSup_" + partnerAppSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanUpdateSup}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canReadOwnRef}
                            name={"canReadOwn_" + partnerAppSurveyItem.appSurveyKey}
                            id={"canReadOwn_" + partnerAppSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanReadOwn}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canWriteRef}
                            name={"canWrite_" + partnerAppSurveyItem.appSurveyKey}
                            id={"canWrite_" + partnerAppSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanWrite}
                            onChange={onResponseChange}
                        />
                    </td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
                        <input type="checkbox" className="mycheckbox"
                            ref={canReviewRef}
                            name={"canReview_" + partnerAppSurveyItem.appSurveyKey}
                            id={"canReview_" + partnerAppSurveyItem.appSurveyKey}
                            defaultChecked={true}
                            checked={isCanReview}
                            onChange={onResponseChange}
                        />
                    </td>
                </>

            ) : (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerAppSurveyItem.canRead}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerAppSurveyItem.takeCorrectiveActionOnSupplier}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerAppSurveyItem.canReadOwn}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerAppSurveyItem.canWrite}</td>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{"" + partnerAppSurveyItem.canReview}</td>
                </>
            )}
            <td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerAppSurveyItem.status}</td>
            <td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
                <div id="submit-spinner"
                    className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
                >
                </div>
                {isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => submitUpdate(event, partnerAppSurveyItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"}
                            onClick={(event) => (submitCancel(event, partnerAppSurveyItem))}>{t("page.cancel")}</button>
                    </>
                ) : (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-2 mb-1"} onClick={(event) => submitDelete(event, partnerAppSurveyItem)}>
                            {partnerAppSurveyItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}

            </td>
        </tr>
    )
}
export default PartnerAppSurveyReadOnlyRow;